import { Lock } from 'lucide-react';

/**
 * In place of the message box when I can't send here (018 FR-007, Q4). No
 * reason is given: naming it would tell one person what the other did.
 */
export const READ_ONLY_TEXT = 'This conversation is read-only.';

export default function ReadOnlyNotice() {
  return (
    <p
      role="status"
      className="flex items-center justify-center gap-2 rounded-3xl bg-muted px-4 py-3 text-sm text-muted-foreground"
    >
      <Lock className="size-4" aria-hidden="true" />
      {READ_ONLY_TEXT}
    </p>
  );
}
